import React, { useState, useRef, useEffect } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Platform, Animated, Easing, Dimensions } from 'react-native';
import { BlurView } from 'expo-blur';
import LoadingSpinner from '../components/LoadingSpinner';
import { LinearGradient } from 'expo-linear-gradient';
import Svg, { Path, LinearGradient as SvgLinearGradient, Defs, Stop, G, ClipPath, Rect } from 'react-native-svg';
import { useNavigation } from '../context/NavigationContext';
import { useAuth } from '../context/AuthContext';
import { useLoading } from '../context/LoadingContext';

const { width: screenWidth } = Dimensions.get('window');
const isMobile = screenWidth < 768;

const LogoIcon = () => (
  <View style={styles.logoContainer}>
    <Svg width={32} height={32} viewBox="0 0 32 32" fill="none">
      <Defs>
        <SvgLinearGradient id="logoGradient" x1="0.451416" y1="14.0276" x2="27.0821" y2="14.0276" gradientUnits="userSpaceOnUse">
          <Stop stopColor="white" />
          <Stop offset="1" stopColor="white" stopOpacity="0.8" />
        </SvgLinearGradient>
      </Defs>
      <Path d="M16.677 1.25562C19.7996 0.337226 23.0663 0.464259 25.1985 2.59644C26.6575 4.05555 27.1775 6.07154 27.0676 8.15894C26.9697 10.0188 26.3735 12.0322 25.3889 14.0281C25.8725 15.0085 26.2589 15.9847 26.5393 16.9382C27.4576 20.0607 27.3306 23.3276 25.1985 25.4597C23.0663 27.5918 19.7995 27.7189 16.677 26.8005C15.7235 26.5201 14.7473 26.1338 13.7668 25.6501C12.7864 26.1338 11.8102 26.5201 10.8567 26.8005C7.73418 27.7189 4.46738 27.5918 2.33521 25.4597C0.877117 24.0016 0.356161 21.987 0.465088 19.9011C0.562309 18.04 1.15951 16.0255 2.14478 14.0281C1.66114 13.0477 1.27484 12.0714 0.994385 11.1179C0.0759825 7.99535 0.203093 4.72863 2.33521 2.59644C4.4674 0.464241 7.73408 0.337201 10.8567 1.25562C11.8102 1.53606 12.7865 1.92141 13.7668 2.40503C14.7472 1.92143 15.7235 1.53605 16.677 1.25562ZM4.05493 17.2117C3.70232 18.2368 3.50609 19.1978 3.46118 20.0574C3.38194 21.5743 3.77277 22.6539 4.4563 23.3376C5.44826 24.3296 7.33188 24.7102 10.01 23.9226C10.1988 23.8671 10.3896 23.8053 10.5823 23.739C9.36803 22.8772 8.17808 21.8739 7.04907 20.7449C5.92007 19.6158 4.91675 18.4259 4.05493 17.2117ZM10.01 4.13354C7.33181 3.34588 5.44828 3.72555 4.4563 4.71753C3.46437 5.70954 3.08463 7.59306 3.87231 10.2712C4.64178 12.8874 6.44901 15.9025 9.17017 18.6238C10.6524 20.106 12.2222 21.3172 13.7668 22.2371C15.3114 21.3172 16.8804 20.1059 18.3625 18.6238C18.7369 18.2494 19.0952 17.8692 19.4358 17.4841C19.9846 16.8636 20.9324 16.8054 21.553 17.3542C22.1735 17.9031 22.2317 18.8509 21.6829 19.4714C21.3017 19.9023 20.9021 20.3274 20.4846 20.7449C19.3556 21.8739 18.1656 22.8772 16.9514 23.739C17.144 23.8053 17.335 23.8671 17.5237 23.9226C20.2018 24.7102 22.0854 24.3296 23.0774 23.3376C24.069 22.3456 24.4488 20.4626 23.6614 17.7849C23.3846 16.8439 22.9734 15.8506 22.4338 14.8386C22.3956 14.7785 22.3615 14.7157 22.3323 14.6511C21.3779 12.9082 20.0445 11.1134 18.3625 9.4314C16.8804 7.94934 15.3113 6.73793 13.7668 5.81812C12.2222 6.738 10.6524 7.94918 9.17017 9.4314C8.77876 9.82281 8.40639 10.2218 8.052 10.6248C7.505 11.2467 6.55688 11.3072 5.93481 10.7605C5.31275 10.2134 5.25198 9.26538 5.79907 8.64331C6.19586 8.19216 6.6125 7.74688 7.04907 7.3103C8.17816 6.18122 9.36794 5.17804 10.5823 4.31616C10.3897 4.24991 10.1987 4.18904 10.01 4.13354ZM13.7385 10.9998C15.3952 10.9998 16.7384 12.3431 16.7385 13.9998C16.7385 15.6566 15.3953 16.9997 13.7385 16.9998C12.0817 16.9998 10.7385 15.6566 10.7385 13.9998C10.7387 12.343 12.0818 10.9998 13.7385 10.9998ZM23.0774 4.71753C22.0854 3.72557 20.2018 3.34592 17.5237 4.13354C17.335 4.18903 17.144 4.24993 16.9514 4.31616C18.1657 5.17803 19.3556 6.18124 20.4846 7.3103C21.6137 8.4394 22.6169 9.62917 23.4788 10.8435C23.8308 9.81988 24.0273 8.86031 24.0725 8.00171C24.1525 6.48297 23.7615 5.40174 23.0774 4.71753Z" fill="url(#logoGradient)" />
    </Svg>
  </View>
);

export const Input = ({ placeholder, value, onChangeText, keyboardType='default', secureTextEntry=false, disabled=false }) => {
  const [isFocused, setIsFocused] = useState(false);
  const focusT = useRef(new Animated.Value(0)).current;
  const onFocus = () => {
    setIsFocused(true);
    Animated.timing(focusT, { toValue: 1, duration: 1500, easing: Easing.bezier(0.22, 1, 0.36, 1), useNativeDriver: true }).start();
  };
  const onBlur = () => {
    setIsFocused(false);
    Animated.timing(focusT, { toValue: 0, duration: 1500, easing: Easing.bezier(0.22, 1, 0.36, 1), useNativeDriver: true }).start();
  };
  return (
  <View style={[styles.inputContainer, isFocused && { borderColor: 'rgba(255, 255, 255, 0.9)' }]}>
    <TextInput
      placeholder={placeholder}
      placeholderTextColor="rgba(255, 255, 255, 0.40)"
      style={styles.input}
      value={value}
      onChangeText={onChangeText}
      keyboardType={keyboardType}
      secureTextEntry={secureTextEntry}
      autoCapitalize="none"
      autoComplete="off"
      autoCorrect={false}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
    />
  </View>
  )
};

export default function RegisterScreen() {
  const { navigateTo } = useNavigation();
  const { register } = useAuth();
  const { startLoading } = useLoading();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  // Animation values
  const pageOpacity = useRef(new Animated.Value(0)).current;

  // Page load animation
  useEffect(() => {
    Animated.timing(pageOpacity, {
      toValue: 1,
      duration: 1000,
      easing: Easing.inOut(Easing.cubic),
      useNativeDriver: true,
    }).start();
  }, []);

  // Exit animation function
  const exitAnimation = (callback) => {
    setIsExiting(true);
    Animated.timing(pageOpacity, {
      toValue: 0,
      duration: 600,
      easing: Easing.in(Easing.cubic),
      useNativeDriver: true,
    }).start(() => {
      if (callback) callback();
    });
  };

  const handleRegister = async () => {
    if (email === '' || password === '') {
      setError('Please fill in all fields');
      return;
    }
    
    setLoading(true);
    setError('');
    
    const { user, error } = await register(email, password);
    
    if (error) {
      setError(error);
      setLoading(false);
    } else {
      // Success - trigger loading screen then navigate
      startLoading();
      exitAnimation(() => {
        navigateTo('Home');
      });
    }
  };

  const goToLogin = () => {
    navigateTo('Login');
  };

  return (
    <View style={styles.container}>
      <Animated.View style={[
        styles.mainContent,
        {
          opacity: pageOpacity,
        }
      ]}>
        <View style={styles.headerSection}>
          <LogoIcon />
          <Text style={styles.brandTitle}>BET OPTIMIZED</Text>
        </View>
        <View style={styles.formContainer}>
          <BlurView intensity={20} tint="dark" style={styles.formCard}>
            <View style={styles.formContent}>
              <Text style={styles.title}>Create an account</Text>
              <View style={styles.formSection}>
                <Input 
                  placeholder="Enter your email" 
                  value={email} 
                  onChangeText={setEmail} 
                  autoCapitalize="none" 
                  disabled={loading || isExiting}
                />
                <Input 
                  placeholder="Enter your password" 
                  value={password} 
                  onChangeText={setPassword} 
                  autoCapitalize="none" 
                  secureTextEntry={true}
                  disabled={loading || isExiting}
                />
                
                {error && <Text style={styles.errorText}>{error}</Text>}
                <TouchableOpacity 
                  style={[styles.primaryButton, (loading || isExiting) && styles.buttonDisabled]} 
                  onPress={handleRegister}
                  disabled={loading || isExiting}
                >
                  <LinearGradient colors={['rgba(0, 0, 0, 0.16)', 'rgba(116, 132, 154, 0.16)']} style={styles.buttonGradient}>
                    {loading ? (
                      <View style={styles.loadingContainer}>
                        <LoadingSpinner size={16} color="rgba(255, 255, 255, 0.9)" />
                        <Text style={styles.primaryButtonText}>Creating Account...</Text>
                      </View>
                    ) : (
                      <Text style={styles.primaryButtonText}>Create Account</Text>
                    )}
                  </LinearGradient>
                </TouchableOpacity>
                <TouchableOpacity onPress={goToLogin} disabled={loading || isExiting}>
                  <Text style={[styles.switchText, (loading || isExiting) && styles.textDisabled]}>
                    Already have an account? Sign in
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </BlurView>
        </View>
      </Animated.View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#131313', borderWidth: 2, borderColor: '#000' },
  mainContent: { flex: 1, paddingTop: isMobile ? 16 : (Platform.OS === 'web' ? 48 : 20), paddingHorizontal: isMobile ? 16 : (Platform.OS === 'web' ? 48 : 20), justifyContent: 'center', alignItems: 'center' },
  headerSection: { alignItems: 'center', marginBottom: isMobile ? 20 : 32, gap: isMobile ? 12 : 16 },
  logoContainer: { width: isMobile ? 48 : 64, height: isMobile ? 48 : 64, justifyContent: 'center', alignItems: 'center' },
  brandTitle: { fontFamily: 'ClimateCrisis', fontSize: isMobile ? 24 : (Platform.OS === 'web' ? 64 : 32), color: 'rgba(255,255,255,0.85)', lineHeight: isMobile ? 28 : (Platform.OS === 'web' ? 64 : 36), textAlign: 'center' },
  formContainer: { width: '100%', maxWidth: 600, minHeight: isMobile ? 320 : 400, justifyContent: 'center', alignItems: 'center' },
  formCard: { width: '100%', height: '100%', padding: isMobile ? 20 : 48, borderRadius: 4, backgroundColor: 'rgba(0,0,0,0.16)', borderWidth: 1, borderColor: 'rgba(255,255,255,0.1)', justifyContent: 'center', alignItems: 'center' },
  formContent: { width: '100%', gap: isMobile ? 18 : 24, alignItems: 'center' },
  title: { fontSize: isMobile ? 22 : 28, fontWeight: '500', color: 'rgba(255,255,255,0.85)' },
  formSection: { width: '100%', gap: isMobile ? 12 : 16 },
  inputContainer: { width: '100%', padding: isMobile ? 10 : 12, borderRadius: 4, backgroundColor: 'transparent', borderWidth: 1, borderColor: 'rgba(255,255,255,0.1)' },
  input: { 
    fontSize: 15, 
    color: '#fff', 
    padding: 0, 
    outlineStyle: 'none',
    ...(Platform.OS === 'web' && {
      // Override autofill styling
      WebkitBoxShadow: '0 0 0 1000px rgba(0,0,0,0.16) inset',
      WebkitTextFillColor: '#fff',
      transition: 'background-color 5000s ease-in-out 0s',
      // Additional autofill overrides
      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 1000px rgba(0,0,0,0.16) inset',
        WebkitTextFillColor: '#fff',
        transition: 'background-color 5000s ease-in-out 0s',
      },
      '&:-webkit-autofill:hover': {
        WebkitBoxShadow: '0 0 0 1000px rgba(0,0,0,0.16) inset',
        WebkitTextFillColor: '#fff',
      },
      '&:-webkit-autofill:focus': {
        WebkitBoxShadow: '0 0 0 1000px rgba(0,0,0,0.16) inset',
        WebkitTextFillColor: '#fff',
      },
      '&:-webkit-autofill:active': {
        WebkitBoxShadow: '0 0 0 1000px rgba(0,0,0,0.16) inset',
        WebkitTextFillColor: '#fff',
      }
    })
  },
  primaryButton: { width: '100%', borderRadius: 4 },
  buttonGradient: { padding: 16, borderRadius: 4, alignItems: 'center', justifyContent: 'center' },
  primaryButtonText: { fontSize: 15, fontWeight: '600', color: 'rgba(255,255,255,0.9)' },
  switchText: { fontSize: 13, color: 'rgba(255,255,255,0.8)', textAlign: 'center' },
  errorText: { fontSize: 13, color: 'rgba(255, 0, 0, 0.85)', textAlign: 'center' },
  loadingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  textDisabled: {
    opacity: 0.5,
  },
});


